import React from "react";
import ToolsContentButton from "../../ToolsCommon/ToolsContentButton";
import TestingApi from "../../../../api/TestingApi";
import { ETestingType } from "../../../../Model/TestingParameter";
import { useTypedSelector } from "../../../../redux/reducers/RootReducer";
import {
  getSuiteMode,
  getImagerTestingState,
} from "../../../../redux/reducers/ModuleStateReducer";
import { ESuiteMode, ETestingState } from "../../../../Model/ModuleState";

type Props = {
  imagerIdentifier: string;
};

export default function CondenserTest({ imagerIdentifier }: Props) {
  const condenserTetingState = useTypedSelector(
    (state) =>
      getImagerTestingState(state, imagerIdentifier).condenser?.state ??
      ETestingState.Stopped
  );
  const suiteMode = useTypedSelector((state) => getSuiteMode(state));
  const isRunningCondenserTest =
    suiteMode === ESuiteMode.Testing &&
    condenserTetingState === ETestingState.Started;

  const isDisabled = suiteMode !== ESuiteMode.Normal;

  const runTest = () => {
    TestingApi.doTesting({
      moduleIdentifier: imagerIdentifier,
      type: ETestingType.Condenser,
    });
  };

  const stopTest = () => {
    TestingApi.stopTesting();
  };

  return (
    <div className={"testing-content"}>
      <div className={"testing-card no-border"} style={{marginTop: 0}}>
        <div>Condenser Test</div>
        <div className={"testing-button-group"}>
          <ToolsContentButton
            text="Stop"
            onClick={stopTest}
            disabled={!isRunningCondenserTest}
            variant="primary"
            colorVariant="black"
          />
          <ToolsContentButton
            text="run"
            onClick={runTest}
            disabled={isDisabled}
            variant="primary"
            colorVariant="default"
          />
        </div>
      </div>
    </div>
  );
}
